module.exports = __webpack_public_path__ + "img/scout-3.1a72b772.jpg";